<template>
  <v-card class="create-a-sor">
    <v-card-title class="justify-center">
      {{ $t("a_sor.create_title") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          type="text"
          :label="$t('a_sor.name')"
          v-model="name"
          :rules="requiredRules"
        ></v-text-field>
        <RbuPeriodInput
          v-if="haveSpecialPermission"
          :label="$t('rbu.base_start')"
          v-model="base_start"
          :rules="requiredRules"
          :min="min"
          :max="max"
        ></RbuPeriodInput>

        <RbuPeriodInput
          v-if="haveSpecialPermission"
          :label="$t('rbu.base_end')"
          v-model="base_end"
          :rules="requiredRules"
          :min="min"
          :max="max"
        ></RbuPeriodInput>

        <!-- <v-text-field
          outlined
          type="number"
          min="1"
          :label="$t('rbu.tcef')"
          suffix="%"
          v-model="tcef"
        ></v-text-field> -->

        <v-text-field
          v-if="haveSpecialPermission"
          outlined
          type="number"
          min="0"
          step=".01"
          suffix="%"
          :label="$t('rbu.head_office_overhead_and_profit')"
          v-model="head_office_overhead_and_profit"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && confirm()"
        depressed
        large
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref, onMounted, computed } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import FileInput from "@/components/FileInput";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";
import { SPECIAL_PERMISSIONS } from "@/constants";

export default {
  name: "CreateContractASoRDialog",
  components: { FileInput, RbuPeriodInput },
  props: {
    contractId: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);
    const min = ref(undefined);
    const max = ref(undefined);

    const name = ref("");
    const base_end = ref("202401");
    const base_start = ref("202401");
    // const tcef = ref(0);
    const head_office_overhead_and_profit = ref(0);
    const excelFile = ref(null);
    const specialConditionsFile = ref(null);

    const haveSpecialPermission = computed(() => {
      return root.$store.getters.hasSpecialPermission(
        SPECIAL_PERMISSIONS.ASOR_RBU
      );
    });

    const confirm = async function () {
      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/create/",
        params: {
          contract_id: props.contractId,
          name: name.value,
          // tcef: tcef.value || 0,
          head_office_overhead_and_profit:
            head_office_overhead_and_profit.value || 0,
          base_start: base_start.value,
          base_end: base_end.value,
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    const getAvailablePeriod = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/available_data_period/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        min.value = response.data.min;
        max.value = response.data.max;
      }
    };

    onMounted(() => {
      getAvailablePeriod();
    });

    return {
      requiredRules,

      name,
      excelFile,
      specialConditionsFile,
      base_end,
      base_start,
      // tcef,
      head_office_overhead_and_profit,

      confirm,
      min,
      max,
      haveSpecialPermission,
    };
  },
};
</script>

<style lang="less">
.create-a-sor {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
